import { useEffect, useState } from 'react';

// Returns the current page path, for use as a sign-in `returning_url`.
//
// Deferred until after hydration via useEffect — window.location isn't available during SSR,
// and reading it during render would produce a server/client markup mismatch.
//
// Returns undefined on the homepage: there's nothing more specific to redirect back to, since
// that's already the default post-login destination.
const useReturningUrl = (): string | undefined => {
  const [returningUrl, setReturningUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    const { pathname } = window.location;
    if (pathname !== '/') {
      setReturningUrl(pathname);
    }
  }, []);

  return returningUrl;
};

export default useReturningUrl;
